module.exports = __webpack_public_path__ + "static/img/tooltip-constellation-outputs.6243b11.png";